export default __webpack_public_path__ + "static/ecofuture-55e9cb07b6295a08fdb03b7238239b51.png";